var _g, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacePart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "img-fluid",
    id: "outputsvg",
    xmlns: "http://www.w3.org/2000/svg",
    style: {
      transform: "none",
      transformOrigin: "50% 50%",
      cursor: "move"
    },
    width: 139,
    height: 139,
    viewBox: "0 0 1390 1390",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "lTADVMUEWqHYRGw3nADqWo",
    fill: "rgb(0,0,0)",
    style: {
      transform: "none"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "pugOntiSo",
    d: "M373 1365 c-45 -19 -89 -85 -118 -177 -20 -63 -25 -100 -25 -184 0 -75 -4 -106 -12 -108 -7 -2 -33 -9 -58 -16 -60 -16 -122 -80 -140 -144 -19 -70 -8 -190 23 -252 34 -68 104 -129 193 -170 65 -31 74 -38 74 -62 1 -40 33 -102 71 -139 19 -18 68 -47 109 -65 72 -31 80 -33 205 -33 125 0 133 1 195 31 106 50 150 109 150 197 0 41 3 45 38 63 88 45 164 99 210 149 70 76 87 116 87 200 0 58 -5 78 -27 117 -56 93 -156 145 -262 135 l-52 -5 4 177 c3 155 1 180 -15 211 -26 51 -108 90 -187 90 -70 0 -113 -20 -163 -77 l-31 -37 -50 45 c-72 65 -150 84 -219 54z m522 -88 c61 -35 67 -54 61 -192 -8 -166 -10 -175 -76 -206 -56 -27 -148 -55 -155 -47 -3 2 -7 85 -11 184 l-6 179 34 39 c28 32 77 61 108 65 3 0 23 -9 45 -22z m-400 -13 c79 -52 82 -59 87 -250 l5 -172 -26 8 c-119 34 -237 75 -244 84 -14 18 1 157 24 224 21 63 74 132 101 132 8 0 32 -12 53 -26z m705 -469 c41 -21 92 -99 92 -141 0 -70 -97 -183 -205 -240 l-54 -27 -34 26 c-76 58 -197 87 -363 87 -179 0 -254 -19 -317 -81 -31 -31 -33 -31 -65 -16 -85 41 -164 153 -164 232 0 64 52 145 108 166 40 15 72 10 202 -30 265 -84 387 -81 593 13 97 45 138 47 207 11z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "l6qxqhQWOjkzUPUlzmgK4y2",
    fill: "rgb(244,211,159)",
    style: {
      transform: "none"
    }
  }, _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "pGAZXni7D",
    d: "M1045 844 c-27 -8 -65 -22 -82 -30 -199 -91 -280 -93 -533 -13 -211 66 -292 52 -349 -58 -15 -31 -21 -60 -21 -108 0 -118 67 -216 184 -271 56 -26 76 -30 76 -14 0 15 55 67 88 84 71 37 259 47 383 21 91 -19 145 -43 193 -86 l38 -33 73 38 c90 46 152 99 196 168 29 45 34 61 34 113 0 52 -5 67 -34 109 -24 34 -48 55 -85 72 -58 27 -90 29 -161 8z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "l74KADzMG0yVI2qaaiKKGrk",
    fill: "rgb(247,248,247)",
    style: {
      transform: "none"
    }
  }, _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "pzg1m7scX",
    d: "M395 1311 c-63 -37 -103 -139 -112 -277 -8 -122 -3 -139 44 -152 21 -5 90 -26 153 -46 132 -41 156 -44 145 -18 -4 9 -9 102 -11 206 l-3 189 -38 40 c-36 39 -102 76 -133 77 -8 0 -29 -8 -45 -19z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p6TMCBCR6",
    d: "M781 1316 c-19 -7 -49 -30 -68 -51 -33 -38 -33 -39 -33 -144 0 -58 3 -157 7 -219 6 -105 7 -112 27 -112 32 0 145 34 201 61 62 30 65 40 71 234 6 171 2 187 -61 222 -44 25 -92 28 -144 9z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacePart);
export default __webpack_public_path__ + "static/media/face_part.e24170ff673934304c748ba6c717fc7a.svg";
export { ForwardRef as ReactComponent };